import { Routes } from '@angular/router';
import { AuthGuard, LaunchDarklyUserGuard, RoleBasedGuard } from 'remarketing-angular-library';
import { AgreementsGuard, GUARDS } from 'smartauction-frontend-micro-library';
import { dashboardReactGuard } from './guards/dashboard-react-version.guard';

export const dashboardRoutes: Routes = [
  {
    // First match wins. Flag off -> dashboardReactGuard's canMatch returns false, this entry does
    // not match, and the Angular DashboardComponent below serves the same path — rollback needs
    // no deploy. Mirrors the bidlist pattern in src/vehicles/vehicles.routes.ts.
    path: 'dashboard',
    loadComponent: () =>
      import('./react-host/react-dashboard-host.component').then(c => c.ReactDashboardHostComponent),
    canMatch: [dashboardReactGuard],
    canActivate: [
      AgreementsGuard,
      LaunchDarklyUserGuard,
      AuthGuard
    ],
    canDeactivate: [RoleBasedGuard],
    data: {
      flag: 'dashboardEnabled',
      guards: [
        GUARDS.TermsOfUseGuard,
        GUARDS.PrivacyPolicyGuard
      ]
    }
  },
  {
    // Flag-off fallback, no canMatch guard. Unchanged from the original single-route config.
    path: 'dashboard',
    loadComponent: () => import('./components/dashboard/dashboard.component').then(c => c.DashboardComponent),
    canActivate: [
      AgreementsGuard,
      LaunchDarklyUserGuard,
      AuthGuard
    ],
    canDeactivate: [RoleBasedGuard],
    data: {
      flag: 'dashboardEnabled',
      guards: [
        GUARDS.TermsOfUseGuard,
        GUARDS.PrivacyPolicyGuard
      ]
    }
  }
];
